import { Switch as AntSwitch } from 'antd';
import styled from 'styled-components';

export const Switch = styled(AntSwitch)`
  &.ant-switch-checked {
    box-shadow: var(--shadow-highlight)
      rgba(var(--blue-60-in-rgb), var(--shadow-highlight-color-opacity));
  }
  &.ant-switch-disabled {
    background-color: var(--gray-50);
  }
`;
